// extracted by mini-css-extract-plugin
export default {"adminButton":"Login_adminButton__-wpqm"};